<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12" md="11">
        <v-row align="baseline">
          <v-col cols="6" md="3">
            <v-text-field
              v-model="currFilters.first_name"
              :label="$t('PROFILE.FIRST_NAME')"
            />
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              v-model="currFilters.last_name"
              :label="$t('PROFILE.LAST_NAME')"
            />
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              v-model="currFilters.abacus_id"
              :label="$t('EREPORTER.PAYROLLS.EMPLOYEE_ABACUS_NUMBER')"
            />
          </v-col>
          <v-col cols="6" md="3">
            <types-filter
              v-model="currFilters.types"
              item-value="id"
              item-text="name"
              :label="$t('ITEM.TYPE')"
              chips
              multiple
              clearable
              small-chips
              deletable-chips
            />
          </v-col>
        </v-row>
        <v-row class="mt-0" align="baseline">
          <v-col cols="6" md="3">
            <v-text-field
              v-model="currFilters.zip"
              :label="$t('PROFILE.ZIP')"
            />
          </v-col>

          <v-col cols="6" md="3">
            <v-text-field
              v-model="currFilters.city"
              :label="$t('PROFILE.CITY')"
            />
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              v-model="currFilters.mobile"
              :label="$t('EMPLOYEES.MOBILE_PHONE')"
            />
          </v-col>
          <v-col cols="6" md="3">
            <statuses-filter
              v-model="currFilters.statuses"
              item-value="id"
              item-text="name"
              :label="$t('ITEM.STATUS')"
              chips
              multiple
              clearable
              small-chips
              deletable-chips
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        md="1"
        align-self="center"
        class="d-flex flex-wrap justify-md-space-between"
        ><v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mb-1 mr-1"
              color="grey"
              depressed
              outlined
              @click="reset"
              v-on="on"
            >
              <v-icon>mdi-filter-remove</v-icon>
            </v-btn></template
          >
          <span>{{ $t('BUTTON.CLEAR_FILTER') }}</span>
        </v-tooltip>
        <v-btn
          class="mb-1"
          type="submit"
          color="primary"
          depressed
          @click.prevent="setFilters"
        >
          {{ $t('BUTTON.FIND') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import StatusesFilter from './filters/StatusesFilter.vue';
import TypesFilter from './filters/TypesFilter';
import { mapState } from 'vuex';
import listFilters from '@/modules/_global/mixins/list-filters';

export default {
  name: 'EmployeesListFilters',

  components: {
    TypesFilter,
    StatusesFilter
  },

  mixins: [listFilters],

  computed: {
    ...mapState('employee', ['filters'])
  },

  methods: {
    reset() {
      this.$refs.form.reset();
      this.currFilters = {};
      this.setFilters();
    }
  }
};
</script>
